import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero, seleccionarCampo } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import CatalogoOrdenPagoEgreso from '../../catalogos/catalogoOrdenPagoEgreso';
import moment from 'moment';

export const AgregarOrdenPago = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    // const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
    const norden = true;

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habiMonPag, setHabiMonPag] = useState(true);
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    const [monaPagar, setMonaPagar] = useState(0.00);
    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    // const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    //const [norden, setNorden] = useState(true);
    const [idOrden, setIdOrden] = useState(0);
    // const [inicializar, setInicializar] = useState(0);
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtId = useRef();
    const txtIdOrdenP = useRef();
    const txtNumOrdenP = useRef();
    const txtRazonSoc = useRef();
    const txtIdprov = useRef();
    const txtIdCtaBan = useRef();
    const txtFecha = useRef();
    const txtConcepto = useRef();
    const txtMontoOrd = useRef();
    const txtMontoAbonado = useRef();
    const txtMontoRetenido = useRef();
    const txtMontoAmortizado = useRef();
    const txtMontoPagar = useRef();
    const txtFechacrea = useRef();
    const txtTipo = useRef();
    const txtClase = useRef();
    const txtChk1 = useRef();
    const txtChk2 = useRef();



    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
    };

    // const onCheck = () => {

    //     if (txtChk1.current.checked) {
    //         setVal2(1);
    //     } else if (txtChk2.current.checked) {
    //         setVal2(2);
    //     }

    // }


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 13 || typeof (event.which) === 'undefined') {


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleAceptaOrdenPago = (numordenpago, razonsocial, idproveedor, ubicacion, fecha, idcompromiso, idordenpago, tipo, concepto) => {
        setMostrar4(false);

        txtId.current.value = norden ? numordenpago : idordenpago;
        txtIdOrdenP.current.value = idordenpago;
        txtNumOrdenP.current.value = numordenpago;
        seleccionarOrdenPago(norden ? numordenpago : idordenpago, props.idproveedor)
        /*txtIdcor.current.value = idcordinacion;
        txtRazon.current.value = razonsocial;
        txtIdprov.current.value = idproveedor;
        txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
        txtConcepto.current.value = observaciones;
        txtMonto.current.value = monto;
        txtMontoiv.current.value = montoiva;
        txtFechacrea.current.value = moment.utc(fechacrea).format('DD-MM-YYYY');
        txtTipo.current.value = tipo;*/

    }
    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarOrdenPago = (id, idprov) => {

        let endpoint = `${op.conexion}/api/administracion/seleccionarordenpagoegreso?idefi=${idefiscal}&numordenpago=${id}&idproveedor=${idprov}&operacion=${props.operacion}&norden=${norden}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                if (response.data.idordenpago > 0) {
                    if (props.operacion === 1) {
                        if (props.ordenesp.length > 0) {
                            if (parseInt(props.ordenesp[0].tipoorden) === 3 && parseInt(props.ordenesp[0].claseorden) === 0) {
                                if (parseInt(response.data.tipoorden) !== 3 || parseInt(response.data.claseorden) !== 0) {
                                    setActivate(false);
                                    txtId.current.value = '';
                                    txtId.current.focus();
                                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se puede agregar una Orden de Pago \n de tipo difrerente al traslado de fondos de terceros', icono: 'informacion' });
                                    return;
                                }
                            } else {
                                if (parseInt(response.data.tipoorden) === 3 && parseInt(response.data.claseorden) === 0) {
                                    setActivate(false);
                                    txtId.current.value = '';
                                    txtId.current.focus();
                                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se puede agregar una Orden de Pago \n de tipo traslado de fondos de terceros', icono: 'informacion' });
                                    return;
                                }
                            }
                        }

                        for (let i = 0; i < props.ordenesp.length; i++) {
                            if (norden ? (props.ordenesp[i].numordenpago === txtId.current.value) : props.ordenesp[i].idordenpago === txtId.current.value) {
                                setActivate(false);
                                txtId.current.value = '';
                                txtId.current.focus();
                                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'LA ORDEN DE PAGO YA EXISTE', icono: 'informacion' });
                                return;
                            }
                        }

                    }


                    /*if (response.data.ubicacion !== '44') {
                        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: response.data.mensajeubi, icono: 'informacion' });
                        setActivate(false);
                        return;
                    }*/
                    setActivate(false);
                    txtIdOrdenP.current.value = response.data.idordenpago;
                    txtNumOrdenP.current.value = response.data.numordenpago;
                    if (response.data.tiposel === 0) {
                        txtConcepto.current.value = response.data.observacionorden.trim() + " " + response.data.concepto.trim();
                    } else {
                        txtConcepto.current.value = response.data.conceptoorden.trim();
                    }
                    txtFecha.current.value = moment.utc(response.data.fechaorden).format('DD/MM/YYYY');
                    txtRazonSoc.current.value = response.data.razonsocial;
                    txtMontoOrd.current.value = formatMoneda(response.data.montoorden.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoAbonado.current.value = formatMoneda(response.data.montoabonado.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoAmortizado.current.value = formatMoneda(response.data.montoamortizado.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoRetenido.current.value = formatMoneda(response.data.montoretenido.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTipo.current.value = response.data.tipoorden;
                    txtClase.current.value = response.data.claseorden;
                    txtIdCtaBan.current.value = response.data.idcuentabancaria;
                    setHabiMonPag(false);
                    let monapaga = Math.round((parseFloat(response.data.montoorden) - parseFloat(response.data.montoabonado) - parseFloat(response.data.montoretenido) - parseFloat(response.data.montoamortizado)) * Math.pow(10, 4)) / Math.pow(10, 4);
                    setMonaPagar(monapaga);
                    txtMontoPagar.current.value = formatMoneda(monapaga.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtMontoPagar.current.focus();
                    setActivo(false);
                    /*txtIdcor.current.value = response.data.idcordinacion;
                    
                    txtIdprov.current.value = response.data.idproveedor;
                    txtFecha.current.value = moment.utc(response.data.fecha).format('DD-MM-YYYY');
                    txtConcepto.current.value = response.data.observacion;
                    txtMonto.current.value = response.data.monto;
                    txtMontoiv.current.value = response.data.montoiva;
                    txtFechacrea.current.value = moment.utc(response.data.fecha_crea).format('DD-MM-YYYY');
                    txtTipo.current.value = response.data.tipo;*/


                } else {
                    txtId.current.value = '';
                    txtIdOrdenP.current.value = '';
                    txtNumOrdenP.current.value = '';
                    txtRazonSoc.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtConcepto.current.value = '';
                    txtMontoOrd.current.value = '';
                    txtMontoAbonado.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                    txtClase.current.value = '';
                    txtIdCtaBan.current.value = '';
                }

            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            txtId.current.value = ''
            txtId.current.focus();

        }).finally(function () {
            setActivate(false);
        });

    }

    const handleOrdenPago = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarOrdenPago(event.target.value, props.idproveedor);
            }
        }
    };

    const changeOrdenPago = (event) => {
        event.preventDefault();
        txtConcepto.current.value = '';
        txtRazonSoc.current.value = '';
        txtMontoOrd.current.value = '';
        txtMontoAmortizado.current.value = '';
        txtMontoAbonado.current.value = '';
        txtMontoRetenido.current.value = '';
        txtMontoPagar.current.value = '';
        setActivo(true);
        setHabiMonPag(true);
    };

    const seleccionarOrdenesPagos = () => {
        if (txtMontoPagar.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡El monto a pagar no debe estar vacio!', icono: 'error' });
            txtMontoPagar.current.value = '0,00';
            //txtMontoPagar.current.focus();
            return;
        } else if (txtMontoPagar.current.value === '0,00') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡El monto a pagar no debe ser cero(0,00)!', icono: 'error' });
            txtMontoPagar.current.value = '0,00';
            //txtMontoPagar.current.focus();
            return;
        }
        blanquear();
        var datos = [];
        const [dia, mes, anio] = txtFecha.current.value.split('/');
        let fecha = new Date(`${anio}-${mes}-${dia}`);
        datos.push({
            numordenpago: norden ? txtId.current.value : txtNumOrdenP.current.value,
            razonsocial: txtRazonSoc.current.value.trim(),
            concepto: txtConcepto.current.value.trim(),
            idproveedor: txtIdprov.current.value,
            idordenpago: txtIdOrdenP.current.value,
            fechaorden: fecha,
            observaciones: txtConcepto.current.value.trim(),
            montoorden: parseFloat(txtMontoOrd.current.value.replace(/\./g, '').replace(',', '.')),
            montoamortizado: parseFloat(txtMontoAmortizado.current.value.replace(/\./g, '').replace(',', '.')),
            montoabonado: parseFloat(txtMontoAbonado.current.value.replace(/\./g, '').replace(',', '.')),
            montoretenido: parseFloat(txtMontoRetenido.current.value.replace(/\./g, '').replace(',', '.')),
            montopagar: parseFloat(txtMontoPagar.current.value.replace(/\./g, '').replace(',', '.')),
            tipoorden: txtTipo.current.value,
            claseorden: txtClase.current.value,
            idcuentabancaria: txtIdCtaBan.current.value,
        })
        //setMensaje({ mostrar: true, titulo: 'Exito', texto: 'La Orden de Pago fue incluida', icono: 'exito' });
        props.onDatos(datos);
        props.onHideCancela();
    };

    const handleInputMontoChange = (event) => {

        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }

            if (event.target.id === 'montopagar') {

                if (parseFloat(monaPagar) < parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'))) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡El Monto Pagado es Mayor al Monto Total de la Orden de Pago!', icono: 'error' });
                    txtMontoPagar.current.value = '0,00';
                    if (event.which === 13) {
                        btnAcepta.current.focus();
                    }
                } else if (parseFloat(monaPagar) > parseFloat(event.target.value.replace(/\./g, '').replace(',', '.')) && props.ordenesp.length > 0) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡No se puede agregar un Abono porque ya existe una Orden de Pago agregada!', icono: 'error' });
                    txtMontoPagar.current.value = '0,00';
                    if (event.which === 13) {
                        btnAcepta.current.focus();
                    }
                } else if (event.which === 13) {
                    btnAcepta.current.focus();
                }
            }


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setIdOrden(0);
                //setNorden(true);
                /*if (espiritu === 0 || espiritu === 2 || espiritu === 4){
                    setNorden(false);
                }*/
                if (props.operacion === 1) {

                } else {
                    txtId.current.value = '';
                    txtIdOrdenP.current.value = '';
                    txtNumOrdenP.current.value = '';
                    txtRazonSoc.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtConcepto.current.value = '';
                    txtMontoOrd.current.value = '';
                    txtMontoAbonado.current.value = '';
                    txtMontoAmortizado.current.value = '';
                    txtMontoRetenido.current.value = '';
                    txtMontoPagar.current.value = '';
                    txtTipo.current.value = '';
                    txtClase.current.value = '';
                    txtIdCtaBan.current.value = '';
                }
            }}>
            <Modal.Header className='azulGradiant px-4 py-2'>
                <h3 className='fs-4 m-0 fw-bold text-light'>
                    Incluir Orden de Pago
                </h3>
                <a type='button' className=" fs-6 fw-bold text-light"
                    onClick={cancelar}>
                    salir<i className="fa fa-times ml-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <CatalogoOrdenPagoEgreso
                    show={mostrar4}
                    onHideCancelar={handleCancelaras}
                    onHideAceptarOrdenPago={handleAceptaOrdenPago}
                    idproveedor={props.idproveedor}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div style={{ height: '300px' }} className='overflow-auto'>
                    <input type='hidden' ref={txtIdOrdenP} />
                    <input type='hidden' ref={txtNumOrdenP} />
                    <input type='hidden' ref={txtRazonSoc} />
                    <input type='hidden' ref={txtIdprov} />
                    <input type='hidden' ref={txtFecha} />
                    <input type='hidden' ref={txtConcepto} />
                    <input type='hidden' ref={txtMontoOrd} />
                    <input type='hidden' ref={txtMontoAbonado} />
                    <input type='hidden' ref={txtFechacrea} />
                    <input type='hidden' ref={txtTipo} />
                    <input type='hidden' ref={txtClase} />
                    <input type='hidden' ref={txtIdCtaBan} />
                    <div className="col-4 col-lg-3 input-group input-group-sm m-0 ml-auto p-0">
                        <label className="input-group-text">
                            Fecha de la Orden:
                        </label>
                        <input type="text"
                            name='codigo'
                            disabled={true}
                            ref={txtFecha}
                            className="form-control"
                            id="inputLogin" />
                    </div>
                    <fieldset className="col-12 border-azul rounded p-4 m-0 d-flex flex-wrap">
                        <legend className="float-none m-0 w-auto">
                            Orden de Pago
                        </legend>
                        <div className="col-4 input-group input-group m-0 mb-2 p-0">
                            <label className="input-group-text">
                                Código:
                            </label>
                            <input type="text"
                                name='codigo'
                                autoComplete="off"
                                ref={txtId}
                                onChange={changeOrdenPago}
                                onKeyUp={handleOrdenPago}
                                onBlur={handleInputNumChange}
                                className="form-control"
                                id="inputLogin" />
                            <button disabled={operacion === 4 || operacion === 2 ? true : deshabilitado}
                                onClick={catalogoClass}
                                className="btn btn-sm btn-info border shadow-none" >
                                <i className="fa fa-search"></i>
                            </button>
                        </div>
                        <div className="col-12  input-group input-group-sm m-0 p-0">
                            <label className="input-group-text" >
                                Concepto:
                            </label>
                            <textarea type="text"
                                className="form-control text-uppercase"
                                style={{ height: '60px' }}
                                disabled={true}
                                ref={txtConcepto}
                                placeholder="Descripción del Documento"
                                id="inputDireccion" />
                        </div>
                        <div className="col-12 input-group input-group-sm m-0 mb-2 mt-2 p-0">
                            <label className="input-group-text">
                                Beneficiario:
                            </label>
                            <input type="text"
                                className="form-control text-uppercase"
                                disabled={true}
                                ref={txtRazonSoc}
                                placeholder="Beneficiario"
                                id="inputDireccion" />
                        </div>
                        <div className='col-12 p-0 m-0 d-flex flex-wrap align-items-center justify-content-end'>
                            <div className="col-md-4 input-group input-group-sm m-0 p-0 pr-2 mb-2">
                                <label className="input-group-text  border-0 fw-bold">
                                    Monto de la Orden:
                                </label>
                                <input type="text"
                                    className="form-control  border-0 text-right"
                                    disabled={true}
                                    ref={txtMontoOrd}
                                    placeholder="0,00"
                                    id="inputDireccion" />
                            </div>
                            <div className="col-md-4 input-group input-group-sm m-0 p-0 pr-2 mb-2">
                                <label className="input-group-text  border-0 fw-bold">
                                    Monto Abonado:
                                </label>
                                <input type="text"
                                    className="form-control  border-0 text-right"
                                    disabled={true}
                                    ref={txtMontoAbonado}
                                    placeholder="0,00"
                                    id="inputDireccion" />
                            </div>
                            <div className="col-md-4 input-group input-group-sm m-0 p-0 mb-2">
                                <label className="input-group-text  border-0 fw-bold">
                                    Monto Retenido:
                                </label>
                                <input type="text"
                                    className="form-control  border-0 text-right"
                                    disabled={true}
                                    ref={txtMontoRetenido}
                                    placeholder="0,00"
                                    id="inputDireccion" />
                            </div>
                            <div className="col-md-4 input-group input-group-sm m-0 p-0 pr-2">
                                <label className="input-group-text  border-0 fw-bold">
                                    Monto Amortizado:
                                </label>
                                <input type="text"
                                    className="form-control  border-0 text-right"
                                    disabled={true}
                                    ref={txtMontoAmortizado}
                                    placeholder="0,00"
                                    id="inputDireccion" />
                            </div>
                            <div className="col-md-4 input-group input-group-sm m-0 p-0">
                                <label className="input-group-text  fw-bold">
                                    Monto a Pagar:
                                </label>
                                <input type="text"
                                    className="form-control text-right "
                                    disabled={habiMonPag}
                                    ref={txtMontoPagar}
                                    onFocus={seleccionarCampo}
                                    onBlur={handleInputMontoChange}
                                    onKeyUp={handleInputMontoChange}
                                    placeholder="0,00"
                                    id="montopagar" />
                            </div>
                        </div>
                    </fieldset>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button"
                    ref={btnAcepta}
                    onClick={seleccionarOrdenesPagos}
                    disabled={activo}
                    className="fw-bold btn btn-success col-md-2 btn-sm rounded-pill">
                    Aceptar <i className="far fa-check-circle"></i>
                </button>
                <button type="button"
                    ref={btnCancela}
                    onClick={cancelar}
                    className="fw-bold text-light btn btn-sm bg-danger col-md-2 rounded-pill">
                    Cancelar <i className="fas fa-window-close"></i> </button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}